module.exports = __webpack_public_path__ + "img/nomore.f986862c.png";